import {
  GetInfoUserProfileRequest,
  PostUpdateInfoUserProfileRequest,
  GetInfoUsersRequest,
  InfoUser,
  InfoUserProfile,
} from './types';

import fetcher, { paramsFormer } from 'utils/fetcher';
import { SET_LOADING_HEADER } from 'utils/fetcher/contants';
import { ResponseFetcher } from 'utils/fetcher/types';
import { API_CURSOS, API_USUARIOSPERFIL, API_VALIDARFOTO } from 'variables';

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getInfoUsers
export const getInfoUsersRequest = async (
  requestBody: GetInfoUsersRequest,
  token: string
): Promise<ResponseFetcher<InfoUser[]>> =>
  fetcher({
    url: `${API_USUARIOSPERFIL}getInfoUsers`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        ...SET_LOADING_HEADER,
      },
    },
  });

export const getInfoUserProfileRequest = async (
  requestBody: GetInfoUserProfileRequest
  // token: string,
): Promise<ResponseFetcher<InfoUserProfile>> =>
  fetcher({
    url: `${API_USUARIOSPERFIL}getInfoUserProfile?${paramsFormer(requestBody)}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const updateUltimoAvisoRequest = async (
  requestBody: PostUpdateInfoUserProfileRequest
): Promise<ResponseFetcher<any>> =>
  fetcher({
    url: `${API_VALIDARFOTO}updateUltimoAviso`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: SET_LOADING_HEADER,
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getCursoSeleccionado
export const getCursoSeleccionado = async (
  requestBody: any /* GetInfoUsersRequest */,
  token: string
): Promise<ResponseFetcher<any /* InfoUser[] */>> =>
  fetcher({
    url: `${API_CURSOS}getCursoSeleccionado?${paramsFormer(requestBody)}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });
